import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ profile }) {
    const year = new Date().getFullYear();
    return (
        <footer data-testid="public-footer" className="border-t border-white/5 bg-ink-900 mt-12">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
                <div className="grid md:grid-cols-12 gap-8 lg:gap-12 mb-12">
                    <div className="md:col-span-4">
                        <h3 className="font-display text-5xl lg:text-6xl text-white tracking-tighter leading-[0.9]">
                            Have an idea?
                            <br />
                            <a href="#contact" className="text-brand link-underline">
                                Let&rsquo;s talk.
                            </a>
                        </h3>
                        <p className="mt-4 text-xs font-mono text-ink-300">
                            Founder & Principal Architect at{" "}
                            <a href="https://kodekami.com" target="_blank" rel="noreferrer" className="text-brand hover:underline">
                                Kodekami
                            </a>
                        </p>
                    </div>
                    <div className="md:col-span-2">
                        <div className="mono-label mb-4">Sitemap</div>
                        <ul className="space-y-2.5 text-ink-200 text-sm">
                            <li><a href="#work" className="hover:text-white transition-colors">Selected work</a></li>
                            <li><Link to="/work" className="hover:text-white transition-colors">All archive</Link></li>
                            <li><a href="#about" className="hover:text-white transition-colors">About</a></li>
                            <li><a href="#skills" className="hover:text-white transition-colors">Capabilities</a></li>
                            <li><a href="#experience" className="hover:text-white transition-colors">Experience</a></li>
                            <li><a href="#contact" className="hover:text-white transition-colors">Contact</a></li>
                        </ul>
                    </div>
                    <div className="md:col-span-3">
                        <div className="mono-label mb-4 text-brand">Ecosystem & Ventures</div>
                        <ul className="space-y-2.5 text-ink-200 text-sm">
                            <li>
                                <a
                                    href="https://kodekami.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:text-white transition-colors inline-flex items-center gap-1 group"
                                >
                                    <span>Kodekami Studio</span>
                                    <span className="text-[10px] font-mono text-brand group-hover:translate-x-0.5 transition-transform">↗</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://wallo.id"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:text-white transition-colors inline-flex items-center gap-1 group"
                                >
                                    <span>Wallo.id — WhatsApp SaaS</span>
                                    <span className="text-[10px] font-mono text-brand group-hover:translate-x-0.5 transition-transform">↗</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://satuhit.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:text-white transition-colors inline-flex items-center gap-1 group"
                                >
                                    <span>Satuhit.com — Top-Up E-Com</span>
                                    <span className="text-[10px] font-mono text-brand group-hover:translate-x-0.5 transition-transform">↗</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="md:col-span-3">
                        <div className="mono-label mb-4">Direct</div>
                        <ul className="space-y-2.5 text-ink-200 text-sm">
                            {profile?.email && (
                                <li><a href={`mailto:${profile.email}`} className="hover:text-brand transition-colors">{profile.email}</a></li>
                            )}
                            {profile?.location && <li>{profile.location}</li>}
                            <li>
                                <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white transition-colors">
                                    Admin
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8 border-t border-white/5">
                    <p className="font-mono text-xs text-ink-300">
                        © {year} {profile?.name || "Akhmad Ferdiansyah"} · Founder & Principal Architect at{" "}
                        <a href="https://kodekami.com" target="_blank" rel="noreferrer" className="text-ink-200 hover:text-brand transition-colors">
                            Kodekami
                        </a>
                        .
                    </p>
                    <div className="flex flex-wrap gap-4">
                        {Object.entries(profile?.social || {})
                            .filter(([, v]) => v)
                            .map(([k, v]) => {
                                const href = v.startsWith("http")
                                    ? v
                                    : k === "discord"
                                    ? (v.includes("discord.") ? `https://${v}` : `https://discord.com/users/${v}`)
                                    : `https://${v}`;
                                return (
                                    <a
                                        key={k}
                                        href={href}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="font-mono text-xs uppercase tracking-wider text-ink-200 hover:text-brand transition-colors"
                                    >
                                        {k}
                                    </a>
                                );
                            })}
                    </div>
                </div>
            </div>
        </footer>
    );
}
